var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis3S90Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ellipsis",
    style: {
      animationPlayState: "running",
      animationDelay: "0s",
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 0,
    fill: "#0089c4",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;0;0;0;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "84;84;84;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48.1758,
    cy: 50,
    r: 10,
    fill: "#005179",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "-1.5s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "-1.5s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 9.46346,
    fill: "#042037",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "-0.75s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "-0.75s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 0.536536,
    fill: "#FBBB36",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.1758,
    cy: 50,
    r: 10,
    fill: "#0089c4",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s",
    className: "",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis3S90Px);
export default __webpack_public_path__ + "static/media/Ellipsis-3s-90px.cc78df414caffd40dd027ff391649ded.svg";
export { ForwardRef as ReactComponent };